export enum ApprovalSerieTable {
    Both = 0,
    Left = 1,
    Right = 2
}